import React from "react";

export default function Gallaryprops(props) {
  return (
    <div className="eimg" data-aos="flip-up">
      <img src={props.gimage} alt="gallary_img" />
      {/* <h5>{props.title}</h5> */}
    </div>
  );
}
